import { Component } from '@angular/core';

@Component({
    selector: 'mon-base-state',
    template: '<div></div>',
    standalone: false,
})
export class BaseStateComponent {
    constructor () {}
}
